module.exports = __webpack_public_path__ + "static/media/logoLm.4b859a16.png";